import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class APIService {
  public _APIServiceDriving = environment.APIServiceDriving;
  public _APIServiceGST = environment.APIServiceGST;
  public _APIServiceGOTP = environment.APIServiceGOTP;
  public _APIServiceVOTP = environment.APIServiceVOTP;
    public _httpOptions;
    //public _DashboardList: Dashboard[] = [];
    constructor(private http: HttpClient) { }
  
  getServiceDriving(Input): Observable<any> {
    var Query = this._APIServiceDriving+Input;
    // console.log(Query);
    const header = new HttpHeaders().set('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MDEyNDAyNDEsIm5iZiI6MTYwMTI0MDI0MSwianRpIjoiMDA3NDRjMmUtMjkyOS00MDcyLTgyMWItZWQ2MjEwYmFiMTAxIiwiZXhwIjoxOTE2NjAwMjQxLCJpZGVudGl0eSI6ImRldi5wb25wdXJlQGFhZGhhYXJhcGkuaW8iLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsicmVhZCJdfX0.BwAYtmmFYST0cM6QpcD9NxM3puR-rgowfP5DEMfq0vU'); // may be localStorage/sessionStorage
    const headers = { headers: header };
    var result = this.http.post<{ data: any }>(Query,'',headers);
    // alert(result);
    // console.log(result);
    return result;
  }

  getServiceGST(Input): Observable<any> {
    var Query = this._APIServiceGST+Input;
    // console.log(Query);
    const header = new HttpHeaders().set('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MDEyNDAyNDEsIm5iZiI6MTYwMTI0MDI0MSwianRpIjoiMDA3NDRjMmUtMjkyOS00MDcyLTgyMWItZWQ2MjEwYmFiMTAxIiwiZXhwIjoxOTE2NjAwMjQxLCJpZGVudGl0eSI6ImRldi5wb25wdXJlQGFhZGhhYXJhcGkuaW8iLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsicmVhZCJdfX0.BwAYtmmFYST0cM6QpcD9NxM3puR-rgowfP5DEMfq0vU'); // may be localStorage/sessionStorage
    const headers = { headers: header };
    return this.http.post<{ data: any }>(Query,'',headers);
}

getServiceGOTP(Input): Observable<any> {
  var Query = this._APIServiceGOTP+Input;
  // console.log(Query);
  const header = new HttpHeaders().set('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MDEyNDAyNDEsIm5iZiI6MTYwMTI0MDI0MSwianRpIjoiMDA3NDRjMmUtMjkyOS00MDcyLTgyMWItZWQ2MjEwYmFiMTAxIiwiZXhwIjoxOTE2NjAwMjQxLCJpZGVudGl0eSI6ImRldi5wb25wdXJlQGFhZGhhYXJhcGkuaW8iLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsicmVhZCJdfX0.BwAYtmmFYST0cM6QpcD9NxM3puR-rgowfP5DEMfq0vU'); // may be localStorage/sessionStorage
  const headers = { headers: header };
  return this.http.post<{ data: any }>(Query,'',headers);
}

getServiceVOTP(Input1,Input2): Observable<any> {
  var Query = this._APIServiceVOTP + Input1 +"&otp="+Input2;
  // console.log(Query);
  const header = new HttpHeaders().set('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MDEyNDAyNDEsIm5iZiI6MTYwMTI0MDI0MSwianRpIjoiMDA3NDRjMmUtMjkyOS00MDcyLTgyMWItZWQ2MjEwYmFiMTAxIiwiZXhwIjoxOTE2NjAwMjQxLCJpZGVudGl0eSI6ImRldi5wb25wdXJlQGFhZGhhYXJhcGkuaW8iLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsicmVhZCJdfX0.BwAYtmmFYST0cM6QpcD9NxM3puR-rgowfP5DEMfq0vU'); // may be localStorage/sessionStorage
  const headers = { headers: header };
  return this.http.post(Query,'',headers);
}
}  